import { map } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import ColorwayCard from 'components/CustomCollectionProductCard/ColorwayCard';
import { Grid, Cell } from 'components/Grid';
import { mediumUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';

const SearchResults = ({ items, trackSearchNavigation }) => (
  <div className="SearchResults">
    <Grid>
      {map(items, item => (
        <Cell
          className="SearchResults__item-wrapper"
          smallUp={{ columns: 6 }}
          key={`item--${item.handle}`}
        >
          <div className="SearchResults__item">
            <ColorwayCard
              isDesktop={false}
              colorway={item}
              enableDiscountPriceColor={true}
              trackNavigation={() => trackSearchNavigation(item?.url)}
            />
          </div>
        </Cell>
      ))}
    </Grid>

    <style jsx>
      {`
        .SearchResults {
          width: 100%;
        }

        .SearchResults__item {
          max-width: 100%;
          width: 100%;
          height: 100%;
        }
      `}
    </style>

    <style jsx global>
      {`
        .SearchResults .ShadowBox {
          height: 100%;
        }

        .SearchResults .Grid {
          display: grid;
          grid-template-columns: repeat(
            auto-fill,
            minmax(calc(50% - ${Theme.get('spacing') * 2}px), 1fr)
          );
          gap: ${Theme.get('spacing') * 2}px;
          min-height: 70vh;
        }

        .SearchResults .SearchResults__item-wrapper.Grid__cell.Grid__cell--small-up-6 {
          width: 100%;
        }

        @media ${mediumUp} {
          .SearchResults .Grid {
            grid-template-columns: repeat(
              auto-fill,
              minmax(calc(33% - ${Theme.get('spacing') * 4}px), 1fr)
            );
            gap: ${Theme.get('spacing') * 4}px;
          }
        }
      `}
    </style>
  </div>
);

SearchResults.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    })
  ).isRequired,
  trackSearchNavigation: PropTypes.func,
};

SearchResults.defaultProps = {
  trackSearchNavigation: () => {},
};

export default SearchResults;
